module.exports = "/_next/static/images/a6187611dc541d3a3e25a90c07ba4576-old-insurances.jpg";